import type { CreditSelf } from './credit';
import { createCreditQueryStore, type CreditQuerySnapshot, type CreditQuerySource } from './creditQueryStore';

/** 账户现有调用方保持 account 字段；底层与价目查询共用身份和并发保护。 */
export interface CreditAccountSnapshot extends Omit<CreditQuerySnapshot<CreditSelf>, 'data'> {
  account: CreditSelf | null;
}

/** 创建账户查询视图；转换快照保持引用稳定，适配 useSyncExternalStore。 */
export function createCreditAccountStore(source: CreditQuerySource<CreditSelf>) {
  const query = createCreditQueryStore(source);
  let previous: CreditQuerySnapshot<CreditSelf> | undefined;
  let snapshot: CreditAccountSnapshot;
  return {
    subscribe: query.subscribe,
    refresh: query.refresh,
    getSnapshot: (): CreditAccountSnapshot => {
      const next = query.getSnapshot();
      if (previous !== next) {
        previous = next;
        const { data, ...state } = next;
        snapshot = { ...state, account: data };
      }
      return snapshot;
    },
  };
}
